import { useState } from "react";
import { Box, Divider, Tab, Tabs, FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";

import { ScenarioModeller, RiskAnticipator, PredictTheFuture } from "../components";

export const VisionStudio = () => {
    const [currentTab, setCurrentTab] = useState("scenario-modeller");
    const [scopeType, setScopeType] = useState("network");
    const [scopeValue, setScopeValue] = useState("all");

    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    const tabs = [
        { value: "scenario-modeller", label: "SCENARIO MODELLER" },
        { value: "risk-anticipator", label: "RISK ANTICIPATOR" },
        { value: "predict-future", label: "PREDICT THE FUTURE" },
    ];

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <TabContext value={currentTab}>
                <Box display="flex" alignItems="center" alignContent="center">
                    <Tabs
                        value={currentTab}
                        onChange={handleChangeTab}
                        aria-label="Vision Studio Tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{ minHeight: "auto" }}
                    >
                        {tabs.map((t) => (
                            <Tab
                                key={t.value}
                                sx={{ height: "auto", minHeight: "auto" }}
                                label={t.label}
                                value={t.value}
                            />
                        ))}
                    </Tabs>
                </Box>
                <Divider />
                <Box display="flex" gap={2} p={2} alignItems="center" bgcolor="background.paper">
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel id="scope-type-label">Scope Type</InputLabel>
                        <Select
                            labelId="scope-type-label"
                            id="scope-type"
                            value={scopeType}
                            label="Scope Type"
                            onChange={(e) => setScopeType(e.target.value)}
                        >
                            <MenuItem value="network">Network</MenuItem>
                            <MenuItem value="workstream">Workstream</MenuItem>
                            <MenuItem value="programme">Programme</MenuItem>
                            <MenuItem value="portfolio">Portfolio</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel id="scope-value-label">Scope Value</InputLabel>
                        <Select
                            labelId="scope-value-label"
                            id="scope-value"
                            value={scopeValue}
                            label="Scope Value"
                            onChange={(e) => setScopeValue(e.target.value)}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="network-a">Network A</MenuItem>
                            <MenuItem value="network-b">Network B</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography variant="body2" color="text.secondary">
                        Snapshot: 06 Jan 2026
                    </Typography>
                </Box>
                <Divider />
                <Box flex={1} overflow="hidden">
                    <TabPanel value="scenario-modeller" sx={{ p: 0, height: "100%" }}>
                        <ScenarioModeller />
                    </TabPanel>
                    <TabPanel value="risk-anticipator" sx={{ p: 0, height: "100%" }}>
                        <RiskAnticipator />
                    </TabPanel>
                    <TabPanel value="predict-future" sx={{ p: 0, height: "100%" }}>
                        <PredictTheFuture />
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    );
};